// global modules
import { ModelDataTable } from '@/components/reusable_components/next'

// local modules
import OrdererService from '@/services/api/Warehouse/WhOrderer'

// local objects
import filters from './filters'
import headers from './headers'

//
export default {
  name: 'orderer-list',
  components: {
    ModelDataTable,
  },
  computed: {

    /**
     * { function_description }
     *
     * @return     {Object}  { description_of_the_return_value }
     */
    tableProps () {
      return {
        service: new OrdererService().toList(),
        filters,
        headers,
        rowsPerPage: 25,
      }
    },
  },
  methods: {

    /**
     * @description
     * 
     */
    submitUpdate ( event ) {
      this.$router.push({ name: 'orderer-update', params: { id: event.item.id } })
    },
  },
  beforeMount () {
    this.setTitle('Solicitudes de abastecimiento')
  },
  beforeRouteEnter ( to, from, next ) {
    next(ctx => {
        if ( !ctx.$can( 'VIEW_ALL_PURCHASE_QUOTATION' ) ) ctx.$router.push('/')
    })
  },
}
